import { render, staticRenderFns } from "./SemappsEnpoints.vue?vue&type=template&id=7ff66876&"
import script from "./SemappsEnpoints.vue?vue&type=script&lang=js&"
export * from "./SemappsEnpoints.vue?vue&type=script&lang=js&"
import style0 from "./SemappsEnpoints.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/common/locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fopt%2Fbuild%2Frepo%2Fsrc%2Fcomponents%2Fsemapps%2FSemappsEnpoints.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports